export const getSinglePlacementStyles = () => ({
  singlePlacement: {},
});
